import Recents from "./Recents";

export default Recents;